import { render } from "./FormHeader.vue?vue&type=template&id=2116ccb6&scoped=true"
import script from "./FormHeader.vue?vue&type=script&lang=js"
export * from "./FormHeader.vue?vue&type=script&lang=js"

import "./FormHeader.vue?vue&type=style&index=0&id=2116ccb6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2116ccb6"]])

export default __exports__